import { Cookie } from '../../../../utils/cookie';

export function getAtlCohortIdFromCookie() {
	let atlCohortId;
	try {
		const cookie = JSON.parse(decodeURIComponent(Cookie.readCookie('atlCohort') || ''));
		atlCohortId = cookie['bucketAll'].index;
	} catch (e) {
		atlCohortId = '';
		console.warn('Cannot parse atlCohort cookie', e);
	}
	return atlCohortId;
}
